
import { defineComponent, ref, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useField, useForm } from 'vee-validate'
import * as yup from 'yup'
import { useStore } from '@/store/index'
import { axios } from '@/plugins/axios'
import BaseFormSubmit from '@/components/BaseFormSubmit.vue'
import { ALERT_COLORS } from '@/store/base'
import LayoutsAuth from '@/layouts/Auth.vue'
import BaseAlert from '@/components/BaseAlert.vue'
import LayoutsAuthWidth from '@/layouts/AuthWidth.vue'

export default defineComponent({
  components: { LayoutsAuth, BaseAlert, BaseFormSubmit, LayoutsAuthWidth },
  setup() {
    const { t } = useI18n()
    const store = useStore()
    const btnDisabled = ref(false)
    const initialValues = computed(() => {
      return {
        name: store.state.user.user?.name,
      }
    })

    const schema = yup.object({
      name: yup.string().required().max(255),
    })

    const { handleSubmit, errors } = useForm({ validationSchema: schema, initialValues })

    const { value: name } = useField<string>('name')

    const onSubmit = handleSubmit(values => {
      btnDisabled.value = true
      axios
        .post('/account/change-name', values)
        .then(response => {
          store.commit('user/setUser', response.data.payload)
          store.commit('base/setAlertMessages', { messages: [t('account.change_name.success')], color: ALERT_COLORS.info })
        })
        .finally(() => btnDisabled.value = false)
    })

    return {
      t,
      errors,
      name,
      onSubmit,
      btnDisabled
    }
  },
})
